export default __webpack_public_path__ + "static/media/timer-home-icon.8dc10dd3.png";